import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[focusable]',
})
export class FocusableDirective implements OnInit, OnDestroy {
  @Input('focusable') focusableTrigger$: Observable<any>;

  @Output() onFocus: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onBlur: EventEmitter<Event> = new EventEmitter<Event>();

  private _el: any;
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;

    if (this.focusableTrigger$) {
      this.focusableTrigger$
        .pipe(takeUntil(this._destroyed))
        .subscribe(() => setTimeout(() => this._el.focus(), 100));
    }
  }

  @HostListener('focus', ['$event'])
  onFocusEvent(evt: Event) {
    this.onFocus.emit(evt);

    this.setClass(true);
  }

  @HostListener('blur', ['$event'])
  onBlurEvent(evt: Event) {
    this.onBlur.emit(evt);

    this.setClass(false);
  }

  setClass(isAdd: boolean) {
    if (this._el) {
      const parentEl = this._el.parentElement;
      const hasFocusClass = 'has-focus';

      if (isAdd) {
        this._renderer.addClass(parentEl, hasFocusClass);
      } else {
        this._renderer.removeClass(parentEl, hasFocusClass);
      }
    }
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
